import React, { useEffect } from "react";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow/index";

export const ThongTinNguoiTaoTicket = ({
  currentForm,
  datanew,
  update,
  KeyCode,
  errors,
  setErrors,
}) => {
  const { register, control } = currentForm;

  const updateTextValue = (field) => (e) => {
    console.log(e, "texxt");
    update({
      ...datanew,
      [field]: e.target.value,
    });

    if (e.target.value === "") {
      setErrors({
        ...errors,
        tenTicket: "Nhập tên ticket!",
      });
    } else {
      setErrors({
        ...errors,
        tenTicket: "",
      });
    }
  };
  
  return (
    <>
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-4">
            <TextInputOnRow
              labelClass="label-control color7-bold"
              inputClass="form-control input-sm"
              wrapperClass="form-group"
              labelText="Tên công ty, cửa hàng"
              starRed="*"
              ref={register}
              inputProps={{
                name: "CongTy",
                value: datanew.CongTy,
                onChange: updateTextValue("CongTy"),

                control: control,
              }}
            ></TextInputOnRow>
          </div>
          <div className="col-md-4">
            <TextInputOnRow
              labelClass="label-control  color7-bold"
              inputClass="form-control input-sm"
              wrapperClass="form-group"
              labelText="Tên người tạo"
              disabled="disabled"
              starRed="*"
              ref={register}
              inputProps={{
                name: "tennguoitao",
                value: datanew.TenNguoiTao,
                onChange: updateTextValue("TenNguoiTao"),

                control: control,
              }}
            ></TextInputOnRow>
          </div>
          <div className="col-md-4">
            <TextInputOnRow labelClass="label-control color7-bold" inputClass="form-control input-sm"  wrapperClass="form-group" labelText="Số điện thoại"    starRed="*"
              inputProps={{
                name: "DienThoai",
                onChange: updateTextValue("DienThoai"),
                value: datanew.DienThoai,
              }}
            ></TextInputOnRow>
            {errors.DienThoai && (
              <span className="canh-bao-red">{errors.DienThoai}</span>
            )}
          </div>

          <div className="col-md-4">
            <TextInputOnRow  labelClass="label-control color7-bold"  inputClass="form-control input-sm" wrapperClass="form-group"  labelText="Email"     disabled="disabled"
              inputProps={{
                name: "Email",
                onChange: updateTextValue("Email"),
                value: datanew.Email,
              }}
            ></TextInputOnRow>
            {errors.Email && (
              <span className="canh-bao-red">{errors.Email}</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
